var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.23325 2.13261C0.6 1.39236 1.36425 0.880859 2.25 0.880859H15.75C16.6357 0.880859 17.4 1.39236 17.7668 2.13261C17.916 2.43411 18 2.77386 18 3.13086V10.6309C18 11.8736 16.9928 12.8809 15.75 12.8809H2.25C1.00725 12.8809 0 11.8736 0 10.6309V3.13086C0 2.77386 0.084 2.43411 0.23325 2.13261ZM2.31558 2.38087L8.64033 5.83087C8.86458 5.95312 9.13458 5.95312 9.35883 5.83087L15.6836 2.38087H2.31558ZM16.5002 3.64464L10.078 7.14714C9.40598 7.51389 8.59448 7.51389 7.92248 7.14714L1.50023 3.64464V10.6309C1.50023 11.0449 1.83623 11.3809 2.25023 11.3809H15.7502C16.1642 11.3809 16.5002 11.0449 16.5002 10.6309V3.64464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBw);
export default __webpack_public_path__ + "static/media/EmailBW.d1d24cfef7a12aff6ae9864c7f2a84f2.svg";
export { ForwardRef as ReactComponent };